// extracted by mini-css-extract-plugin
module.exports = {"date":"AuctionActivityDateHeadline_date__3MSCC","wrapper":"AuctionActivityDateHeadline_wrapper__2YbIC"};